<template>
  <div>
    <APCDelconHead
        :showFilter="showFilter"
        :navTabs="navTabs"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeTab="(data) => $emit('changeTab', data)"
        @reload="$emit('reload')"
        @selectAll="selectAll"
        @setTrackForSelectedUnions="(selectedOption, trackNumber) => $emit('setTrackForSelectedUnions', selectedOption, trackNumber)"
    />

    <div class="table-filter-wrap">

      <APCDelconFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <APCDelconTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          :navTabs="navTabs"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
          @removeItem="(id) => { $emit('removeItem', id) }"
      />
    </div>
  </div>
</template>

<script>


  import APCDelconHead from "./APCDelconHead/APCDelconHead";
  import APCDelconFilter from "./APCDelconFilter/APCDelconFilter";
  import APCDelconTable from "./APCDelconTable/APCDelconTable";

  export default {
    name: "APCDelconTableUser",

    components: {
      APCDelconHead,
      APCDelconFilter,
      APCDelconTable,
    },

    props: {
      typeShops: String,
      countFilterParams: Number,
      filterGetParams: Object,
      navTabs: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    watch: {
      filterGetParams(newVal) {
        this.filterGetParams = newVal
      },
      countFilterParams(newVal) {
        this.countFilterParams = newVal
      },
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
